export class OptionSummary {
    public label?: string;
    public quantity?: number;
    public precalculatedQuantity?: string;
    public appliedPrice?: string;


    constructor(label: string, quantity: number, precalculatedQuantity: string, appliedPrice: string) {
        this.label = label;
        this.quantity = quantity;
        this.precalculatedQuantity = precalculatedQuantity;
        this.appliedPrice = appliedPrice;
    }
}
